import React from 'react';
import { T } from '../../../../../common/locale/translate';

export default class TextInput extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: '',
      active: false
    };
  }

  render = () => (
    <div
      className={'input-wrapper ' + (this.props.class || '')}
      ref={() => {
        this.reset = this.reset.bind(this);
      }}
    >
      <div
        className={'animated-text-form ' + (this.state.active ? 'active' : '')}
      >
        <label htmlFor={this.props.id} className="animated-text-label">
          <span className="animated-text-label-name">
            {this.props.label}
            {this.props.required && '*'}
            {this.props.requiredRed && (
              <span style={{ color: '#f44336' }}>*</span>
            )}
          </span>
        </label>
        <input
          type={this.props.type || 'text'}
          className="animated-text-input"
          placeholder=""
          id={this.props.id}
          name={this.props.name}
          value={this.state.value}
          onChange={this.onChange}
          onFocus={this.handleFocus}
          onBlur={this.handleBlur}
        />
      </div>
      <div className="validation-message">
        {this.props.validationMessage || T('invalid_content')}
      </div>
    </div>
  );

  onChange = event => {
    this.setState({ value: event.target.value }, () => {
      this.props.onChangeCallback(this.props.name, this.state.value);
    });
  };
  handleBlur = () => {
    this.setState({ active: false });
  };

  handleFocus = () => {
    this.setState({ active: true });
  };

  reset() {
    this.setState({ value: '' });
    return 'done';
  }
}



// WEBPACK FOOTER //
// ./app/javascript/pages/reservation/default/input.jsx